import { PrimaryButton, TextArea, TextField } from "../../../../Libraries";
import { postCreateBranch, putUpdateBranch } from "../../../../../api";
import { useLanguage, useToast } from "../../../../../context";
import { Collapse, SubHeader } from "../../../../common";
import { SARNO_REGEX } from "../../../../../constants";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const CreateLocation = ({ from, item }) => {

    const { invokeToast } = useToast();
    const { I18n } = useLanguage();
    let navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [locaiton, setLocation] = useState({
        longitude: `${item?.location?.coordinates[1] || ''}`,
        latitude: `${item?.location?.coordinates[0] || ''}`,
        address: item?.address || '',
        phone: item?.phone || '',
        code: item?.code || '',
        name: item?.name || '',
    });

    const validateLocation = () => {
        let obj = {};

        if (locaiton['phone'] && !SARNO_REGEX.test(locaiton['phone'])) obj = { ...obj, phone: 'Phone is invalid' };
        if (!locaiton['latitude']) obj = { ...obj, latitude: 'Location latitude is required' };
        if (!locaiton['longitude']) obj = { ...obj, longitude: 'Location longitude is required' };
        if (!locaiton['address']) obj = { ...obj, address: 'Address is required' };
        if (!locaiton['name']) obj = { ...obj, name: 'Location name is required' };
        if (!locaiton['code']) obj = { ...obj, code: 'Location code is required' };

        return obj;
    };

    const onSave = async (event) => {
        window.scrollTo({ top: 0 });
        event.stopPropagation();
        event.preventDefault();

        try {

            if (Object.values(validateLocation()).length) {
                setErrors(validateLocation());
                return;
            };

            setLoading(true);

            const { latitude, longitude, address, phone, name, code } = locaiton;

            let params = {
                longitude,
                latitude,
                address,
                phone,
                name,
                code
            };

            from == 'edit' ? await putUpdateBranch(item._id, params) : await postCreateBranch(params);

            invokeToast({ message: `Location ${from == 'edit' ? 'updated' : 'created'} successfully!`, type: 'success' });

            navigate('/location');
        } catch (err) {
            invokeToast({ message: err, type: 'danger' });
        } finally {
            setLoading(false);
        }
    };

    const onChange = (key, value) => {
        let error = { ...errors };
        setLocation(prev => {
            let all = { ...prev };
            all[key] = value;
            if (error[key]) error[key] = '';
            return all;
        });
        if (errors[key]) setErrors(error);
    };

    const handleBack = () => navigate(-1);
    const onCancel = () => navigate(-1);

    return (
        <div className="page-wrapper">
            <div className="content">
                <SubHeader
                    data={{
                        title: from == 'edit' ? 'edit_location' : 'new_location',
                        subTitle: from == 'edit' ? '' : 'create_new_location',
                        flip: true,
                        actions: [{
                            className: 'btn btn-added color',
                            title: 'back_to_location',
                            action: handleBack,
                            icon: 'arrow-left',
                        }]
                    }}
                />

                <form type="submit" onSubmit={onSave} >
                    <div className="card">
                        <div className="card-body add-product pb-0">
                            <div
                                className="accordion-card-one accordion"
                                id="accordionExample"
                            >
                                <div className="accordion-item">
                                    <Collapse
                                        data={{
                                            title: I18n.location_information,
                                            target: 'collapseOne',
                                            id: 'headingOne',
                                            icon: 'info',
                                        }} >
                                    </Collapse>

                                    <div
                                        id="collapseOne"
                                        className="accordion-collapse collapse show"
                                        aria-labelledby="headingOne"
                                        data-bs-parent="#accordionExample"
                                    >
                                        <div className="accordion-body">
                                            <div className="row">
                                                <TextField
                                                    onChange={(value) => onChange('name', value)}
                                                    containerClass='col-lg-4 col-sm-6 col-12'
                                                    placeholder="enter_location_name"
                                                    innerContClass='mb-3 add-product'
                                                    label={'location_name'}
                                                    value={locaiton.name}
                                                    error={errors?.name}
                                                    type={"text"}
                                                />

                                                <TextField
                                                    onChange={(value) => onChange('phone', value)}
                                                    containerClass='col-lg-4 col-sm-6 col-12'
                                                    placeholder="enter_location_phone"
                                                    innerContClass='mb-3 add-product'
                                                    value={locaiton.phone}
                                                    error={errors?.phone}
                                                    label={'phone'}
                                                    type={"text"}
                                                />

                                                <TextField
                                                    onChange={(value) => onChange('code', value)}
                                                    containerClass='col-lg-4 col-sm-6 col-12'
                                                    placeholder="enter_location_code"
                                                    innerContClass='mb-3 add-product'
                                                    value={locaiton.code}
                                                    error={errors?.code}
                                                    label={'code'}
                                                    type={"text"}
                                                    onlyNumber
                                                />
                                            </div>

                                            <div className="row">
                                                <TextField
                                                    onChange={(value) => onChange('latitude', value)}
                                                    containerClass='col-lg-4 col-sm-6 col-12'
                                                    placeholder="enter_location_latitude"
                                                    innerContClass='mb-3 add-product'
                                                    value={locaiton.latitude}
                                                    error={errors?.latitude}
                                                    label={'latitude'}
                                                    type={"text"}
                                                    onlyDot
                                                />
                                                <TextField
                                                    onChange={(value) => onChange('longitude', value)}
                                                    containerClass='col-lg-4 col-sm-6 col-12'
                                                    placeholder="enter_location_longitude"
                                                    innerContClass='mb-3 add-product'
                                                    value={locaiton.longitude}
                                                    error={errors?.longitude}
                                                    label={'longitude'}
                                                    type={"text"}
                                                    onlyDot
                                                />
                                            </div>

                                            <div className="col-lg-12">
                                                <TextArea
                                                    className="input-blocks summer-description-box transfer mb-3"
                                                    onChange={(value) => onChange('address', value)}
                                                    placeholder="enter_location_address"
                                                    value={locaiton.address}
                                                    error={errors?.address}
                                                    lable="address"
                                                    maxLength={60}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <div className="btn-addproduct mb-4">
                            <PrimaryButton
                                className='btn btn-cancel me-2'
                                onClick={onCancel}
                                title={'cancel'}
                                type="button"
                            />
                            <PrimaryButton
                                className='btn btn-submit'
                                title={'save_location'}
                                loading={loading}
                                type="submit"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateLocation;